import { Technique } from "./technique";
import allTechniqueGameDescriptions from "./allTechniqueGameDescriptions";

export default function allGamesByTechnique(technique: Technique) {
  return Object.values(allTechniqueGameDescriptions[technique].games);
}
